<c-row class="justify-content-between">
  <c-col *ngIf="title">
    <h3 class="chart-header-row__title">
      <!-- {{model == 1 ? 'Department' : 'Regional'}} Average Utilisation Score  -->
      {{title}}
    </h3>
  </c-col>
  <c-col>
    <select aria-label="Select Time range" [ngModel]="model" (change)="modelChange.emit($event)" cSelect>
      <option *ngFor="let option of options" [value]="option.value"  [selected]="option.value === model">{{option.label}}</option>
    </select>
  </c-col>
</c-row>
